import { render, staticRenderFns } from "./UserInfoModal.vue?vue&type=template&id=2defbad4&"
import script from "./UserInfoModal.vue?vue&type=script&lang=js&"
export * from "./UserInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoModal.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports